import { render, staticRenderFns } from "./BudgetLimits2.vue?vue&type=template&id=21aa8eb8&scoped=true&"
import script from "./BudgetLimits2.vue?vue&type=script&lang=js&"
export * from "./BudgetLimits2.vue?vue&type=script&lang=js&"
import style0 from "./BudgetLimits2.vue?vue&type=style&index=0&id=21aa8eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa8eb8",
  null
  
)

export default component.exports